<template>
  <section id="about" class="py-32 bg-gradient-to-b from-amber-50 to-white relative overflow-hidden">
    <div class="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-amber-100/50 to-transparent"></div>
    
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div class="grid lg:grid-cols-2 gap-20 items-center">
        <div class="order-2 lg:order-1">
          <div class="inline-flex items-center px-5 py-2.5 bg-amber-100 rounded-full mb-8">
            <Factory :size="20" class="mr-2 text-amber-600" />
            <span class="text-sm font-semibold text-amber-700">关于我们</span>
          </div>
          
          <h2 class="text-4xl sm:text-5xl font-bold font-display text-dark mb-8 leading-tight">
            宁夏西明
            <span class="text-amber-600">食品有限公司</span>
          </h2>
          
          <p class="text-lg text-gray-600 mb-6 leading-relaxed">
            宁夏西明食品有限公司是一家专业从事食用油脂研发、生产和销售的现代化企业。公司位于宁夏西吉县，拥有先进的生产设备和专业的技术团队，年产量可达数万吨。
          </p>
          
          <p class="text-lg text-gray-600 mb-10 leading-relaxed">
            我们严格遵循国家食品安全标准，从原料采购到成品出厂，每一个环节都经过严格检测，确保产品质量稳定可靠。产品远销全国各地，深受客户信赖。
          </p>
          
          <div class="grid grid-cols-2 gap-8">
            <div class="group">
              <div class="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-amber-500 transition-all duration-300">
                <Award :size="32" class="text-amber-600 group-hover:text-white transition-colors" />
              </div>
              <div class="text-2xl font-bold text-dark mb-1">ISO认证</div>
              <div class="text-sm text-gray-500">质量保证</div>
            </div>
            <div class="group">
              <div class="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-orange-500 transition-all duration-300">
                <Shield :size="32" class="text-orange-600 group-hover:text-white transition-colors" />
              </div>
              <div class="text-2xl font-bold text-dark mb-1">SGS检测</div>
              <div class="text-sm text-gray-500">安全可靠</div>
            </div>
            <div class="group">
              <div class="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-green-500 transition-all duration-300">
                <Users :size="32" class="text-green-600 group-hover:text-white transition-colors" />
              </div>
              <div class="text-2xl font-bold text-dark mb-1">500+客户</div>
              <div class="text-sm text-gray-500">信赖之选</div>
            </div>
            <div class="group">
              <div class="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-blue-500 transition-all duration-300">
                <Truck :size="32" class="text-blue-600 group-hover:text-white transition-colors" />
              </div>
              <div class="text-2xl font-bold text-dark mb-1">全国配送</div>
              <div class="text-sm text-gray-500">冷链物流</div>
            </div>
          </div>
        </div>
        
        <div class="order-1 lg:order-2 relative">
          <div class="relative">
            <div class="absolute -top-8 -left-8 w-full h-full bg-amber-200/30 rounded-3xl"></div>
            <img :src="aboutImage" 
                 alt="食品加工厂" class="relative w-full rounded-3xl shadow-2xl" />
            
            <div class="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 shadow-2xl">
              <div class="flex items-center gap-4">
                <div class="w-14 h-14 bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl flex items-center justify-center">
                  <Clock :size="28" class="text-white" />
                </div>
                <div>
                  <div class="text-3xl font-bold text-gray-800">20+年</div>
                  <div class="text-gray-500">行业深耕</div>
                </div>
              </div>
            </div>
            
            <div class="absolute -top-4 -left-4 bg-white rounded-2xl p-5 shadow-xl">
              <div class="flex items-center gap-4">
                <div class="flex -space-x-3">
                  <div class="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center text-sm font-bold text-amber-600 border-2 border-white">宁</div>
                  <div class="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-sm font-bold text-orange-600 border-2 border-white">夏</div>
                  <div class="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-sm font-bold text-yellow-600 border-2 border-white">西</div>
                </div>
                <div>
                  <div class="font-semibold text-gray-800">品质第一</div>
                  <div class="text-xs text-gray-500">安全可靠</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { Factory, Award, Shield, Users, Truck, Clock } from 'lucide-vue-next'
import aboutImage from '@/assets/images/about.jpg'
</script>
